// extracted by mini-css-extract-plugin
export default {"bookingsListWrapper":"BookingsList_bookingsListWrapper__LGXHi"};